import getStatusManager from "./status";
import getConstants from "./constants";
import setContents, {requestForUserPage, userPageFunctions, adminMenu} from "./contents";
import getComponent from "./component";

const postTypeConfig = {
    getStatusManager,
    getConstants,
    setContents,
    requestForUserPage,
    getComponent,
    userPageFunctions,
    adminMenu
};

export default postTypeConfig;
